<div class="ui-dashboard">

  <div class="dashboard-wrapper">

    <!-- Heading & Dates -->
    <div class="p-b-10">
      <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">
        <!-- LHS -->
        <div>
          <h2 class="dashboard-head">Claims Dashboard</h2>
          <p class="dashboard-head-sub">
            <strong>Welcome back, Mithika!</strong> Here's a quick summary of key data points
          </p>
        </div>
        <!-- RHS -->
        <div class="text-a-right">
          <!-- Date Range -->
          <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDashDataChange($event)" class="dash-date-range">
          </nz-range-picker>
          <!-- Color Scheme -->
          <nz-select nzShowSearch  style="display: inline-block; text-align: left; width: 130px;" class="" nzAllowClear nzPlaceHolder="Color Scheme"
                     [(ngModel)]="colorSchemeTempModel" (ngModelChange)="colorSchemeModelChange()">
            <nz-option *ngFor="let z of colorSchemesNames; let i=index;" [nzValue]="i" [nzLabel]="z"></nz-option>
          </nz-select>
        </div>
      </div>
    </div>

    <div>
      <h5 class="d-b p-b-10">
        <!-- Dropdown for selection -->
        <nz-select nzShowSearch  nzPlaceHolder="Choose" [(ngModel)]="persona" style="min-width: 200px;" (ngModelChange)="onDashDataChange(900)">
          <nz-option nzValue="staff" nzLabel="Staff"></nz-option>
          <nz-option nzValue="investigator" nzLabel="Investigator"></nz-option>
        </nz-select>
        <!-- Title -->
        <span class="p-l-10 f-s-1-1r"><span class="text-t-capitalize">{{persona}}</span> summary:  01 Dec 2019 - 18 Dec 2019</span>
      </h5>
    </div>


    <!--------------- STAFF -------------->
    <div *ngIf="persona=='staff'">
      <!-- TOP WIDGETS -->
      <div *ngIf="widgetReady" class="stat-widgets grid grid-5x grid-gap-20 grid-5x-responsive">
        <div *ngFor="let item of dataCARDS; let i=index;" class="stat-widget" [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
          <div class="stat-widget-body">
            <strong>{{item.value}}</strong>
            {{item.name}}
          </div>
          <div *ngIf="item.breakup" class="stat-widget-footer">
            <table class="w-100-pc">
              <tr *ngFor="let subItem of item.breakup">
                <td>{{subItem.key}}</td>
                <td class="text-a-right">{{subItem.value}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- AGENTS SEARCH TABLE -->
      <div class="m-t-20">
        <div class="w-100-pc">
          <div class="widget widget-shadow">
            <div class="flexie-auto-grid">
              <!-- HEADING -->
              <div>
                <!--<h5 class="d-b p-t-b-10">
                  <nz-select nzShowSearch  nzPlaceHolder="Choose" [ngModel]="'staff'">
                    <nz-option nzValue="staff" nzLabel="Staff"></nz-option>
                    <nz-option nzValue="investigator" nzLabel="Investigator"></nz-option>
                  </nz-select>
                </h5>-->
              </div>
              <!-- SEARCH -->
              <div class="text-a-right p-b-10">
                <nz-input-group [nzSuffix]="suffixIconSearch" style="max-width: 260px">
                  <input type="text" nz-input placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="agentSearch()"/>
                </nz-input-group>
                <ng-template #suffixIconSearch>
                  <i *ngIf="!searchTerm" class="anticon anticon-search"></i>
                  <i *ngIf="searchTerm" (click)="searchTerm=null" nzTheme="fill" class="ant-input-clear-icon anticon anticon-close-circle"></i>
                </ng-template>
              </div>
            </div>
            <nz-table *ngIf="widgetReady" #basicTable [nzData]="dataSet" nzSize="small" [nzShowPagination]="false" class="d-b" [nzScroll]="{x: '480px'}"
                      [nzLoading]="isSearching">
              <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Tasks</th>
                <th>Completed</th>
                <th>Registration</th>
                <th>Adjudication</th>
                <th>Payout</th>
                <th>Average SLA</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let u of basicTable.data">
                <td>
                  <!-- Low Load -->
                  <nz-avatar *ngIf="'low'==getUserLoad(u)" style="color:#FFF; background-color:#66a355;" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'Low load'"></nz-avatar>
                  <!-- Moderate Load -->
                  <nz-avatar *ngIf="'med'==getUserLoad(u)" style="color:#FFF; background-color:rgba(237,104,0,0.6);" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'Moderate load'"></nz-avatar>
                  <!-- Heavy load -->
                  <nz-avatar *ngIf="'hig'==getUserLoad(u)" style="color:#FFF; background-color:rgba(238,90,35,0.98);" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'High load'"></nz-avatar>
                </td>
                <td>
                  {{u.name}}
                  <nz-progress nz-tooltip [nzTooltipTitle]="u.completed+' of '+ u.tasks+' done'" nzSize="small" [nzPercent]="u.completed/u.tasks*100" [nzShowInfo]="false"></nz-progress>
                </td>
                <td>{{u.tasks}}</td>
                <td>{{u.completed}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 5h</span></td>
                <td>{{u.pendingInt}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 2.5h</span></td>
                <td>
                  {{u.pendingAdj}}
                  <span class="d-b f-s-tiny-alt col-grey-dark">Pending Referral: 3</span>
                  <span class="d-b f-s-tiny-alt col-grey-dark">Pending Investigation: 1</span>
                </td>
                <td>{{u.pendingPay}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 1.25h</span></td>
                <td>{{u.sla}}h<!--<a [routerLink]="['/app/agent-analytics']">Details</a>--></td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>


    <!--------------- INVESTIGATOR -------------->
    <div *ngIf="persona=='investigator'">
      <!-- Top widgets -->
      <div class="grid grid-2x grid-2x-responsive grid-gap-20">

        <div class="grid grid-2x grid-2x-responsive grid-gap-20">
          <div *ngFor="let item of dataCARDSInvestigator; let i=index;" class="stat-widget" [ngStyle]="{ 'backgroundColor': colorScheme.domain[i], 'height': 'auto' }">
            <div class="stat-widget-body">
              <strong>{{item.value}}</strong>
              {{item.name}}
            </div>
            <div *ngIf="item.breakup" class="stat-widget-footer">
              <table class="w-100-pc">
                <tr *ngFor="let subItem of item.breakup">
                  <td>{{subItem.key}}</td>
                  <td class="text-a-right">{{subItem.value}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="widget widget-shadow" style="width: 100%;">
          <h5 class="d-b p-t-b-10">Tasks</h5>
          <div class="widget-wrapper" *ngIf="widgetReady">
            <div class="widget-responsive">
              <ngx-charts-bar-vertical
                [view]="view"
                [scheme]="colorScheme"
                [results]="single"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="null"
                [yAxisLabel]="'Investigations'"
                (select)="onSelect($event)">
              </ngx-charts-bar-vertical>
            </div>
          </div>
        </div>

      </div>

      <!-- INVESTIGATOR SEARCH TABLE -->
      <div class="m-t-20">
        <div class="w-100-pc">
          <div class="widget widget-shadow">
            <div class="flexie-auto-grid">
              <!-- HEADING -->
              <div>
                <!--<h5 class="d-b p-t-b-10">
                  <nz-select nzShowSearch  nzPlaceHolder="Choose" [ngModel]="'staff'">
                    <nz-option nzValue="staff" nzLabel="Staff"></nz-option>
                    <nz-option nzValue="investigator" nzLabel="Investigator"></nz-option>
                  </nz-select>
                </h5>-->
              </div>
              <!-- SEARCH -->
              <div class="text-a-right p-b-10">
                <nz-input-group [nzSuffix]="suffixIconSearch" style="max-width: 260px">
                  <input type="text" nz-input placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="agentSearch()"/>
                </nz-input-group>
                <ng-template #suffixIconSearch>
                  <i *ngIf="!searchTerm" class="anticon anticon-search"></i>
                  <i *ngIf="searchTerm" (click)="searchTerm=null" nzTheme="fill" class="ant-input-clear-icon anticon anticon-close-circle"></i>
                </ng-template>
              </div>
            </div>
            <nz-table *ngIf="widgetReady" #basicTable [nzData]="dataSet" nzSize="small" [nzShowPagination]="false" class="d-b" [nzScroll]="{x: '480px'}"
                      [nzLoading]="isSearching">
              <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Tasks</th>
                <th>Completed</th>
                <th>Average SLA</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let u of basicTable.data">
                <td>
                  <!-- Low Load -->
                  <nz-avatar *ngIf="'low'==getUserLoad(u)" style="color:#FFF; background-color:#66a355;" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'Low load'"></nz-avatar>
                  <!-- Moderate Load -->
                  <nz-avatar *ngIf="'med'==getUserLoad(u)" style="color:#FFF; background-color:rgba(237,104,0,0.6);" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'Moderate load'"></nz-avatar>
                  <!-- Heavy load -->
                  <nz-avatar *ngIf="'hig'==getUserLoad(u)" style="color:#FFF; background-color:rgba(238,90,35,0.98);" nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTooltipTitle]="'High load'"></nz-avatar>
                </td>
                <td>
                  {{u.name}}
                  <nz-progress nz-tooltip [nzTooltipTitle]="u.completed+' of '+ u.tasks+' done'" nzSize="small" [nzPercent]="u.completed/u.tasks*100" [nzShowInfo]="false"></nz-progress>
                </td>
                <td>{{u.tasks}}</td>
                <td>{{u.completed}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 5h</span></td>
                <td>{{u.sla}}h<!--<a [routerLink]="['/app/agent-analytics']">Details</a>--></td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>





    <!--<nz-progress [nzPercent]="100" nzStatus="active" [nzShowInfo]="false"></nz-progress>-->



  </div>


</div>
